import { FC, Suspense, useMemo } from 'react'
import { useAtomValue } from 'jotai'
import * as atoms from 'src/v2/state/owner-reveal/parcel'
import { convertOwnerToSidebarResultListItem } from 'src/v2/utils/entity'
import { ResultItem, SidebarResultListItem } from 'src/v2/components/sidebar-result-list'
import styled from '@emotion/styled'
import { SidebarResultListLoader } from 'src/v2/components/skeleton-loaders'
import { useMapExplorerNavigation } from 'src/views/map-explorer/sidebar/search/use-navigation'
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 16px;
`

const List: FC = () => {
  const owners = useAtomValue(atoms.parcelOwners)
  const { selectOwner } = useMapExplorerNavigation()

  const onClickOwner = async (ownerId: string) => {
    await selectOwner(ownerId)
  }

  const ownerItems = useMemo<SidebarResultListItem[]>(() => {
    if (!owners || owners.length === 0) {
      return []
    }

    return owners.map(convertOwnerToSidebarResultListItem)
  }, [owners])

  return (
    <>
      {ownerItems.map((item) => (
        <ResultItem key={item.id} item={item} onClick={() => onClickOwner(item.id)} />
      ))}
    </>
  )
}

export const ReportedOwnersList: FC = () => {
  return (
    <Container>
      <Suspense fallback={<SidebarResultListLoader numberOfItems={4} />}>
        <List />
      </Suspense>
    </Container>
  )
}
